import {Controller} from '@stubhub/react-store-provider';

import {
  buildYourOrderQuantitySelector,
  byoPriceSelector,
  enableQuantityPickerSelector,
  isPriceLoadingSelector,
  listingPriceSelector,
  splitVectorSelector,
} from './selectors';

export default new Controller({
  namespace: 'ticketQuantityPicker',
  mapStateToProps: (state = {}) => {
    return {
      price: listingPriceSelector(state) || byoPriceSelector(state),
      isPriceLoading: isPriceLoadingSelector(state),
      splitVector: splitVectorSelector(state),
      selectedQuantity: buildYourOrderQuantitySelector(state),
      enableQuantityPicker: enableQuantityPickerSelector(state),
    };
  },
});
